import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { XFieldComponent } from '../x-field/x-field.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'x-input-password',
  templateUrl: 'x-input-password.component.html',
  styleUrls: ['./x-input-password.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => XInputPasswordComponent), multi: true }
  ]
})
export class XInputPasswordComponent extends XFieldComponent {

  constructor(
    protected matSnackBar: MatSnackBar
  ) {
    super(matSnackBar);
  }
}
